import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import React, { useEffect } from 'react'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { useStore } from '../../../../../store'
import { screenWidth } from '../../../../../utils/helpers/commonUtils'
import { paths } from '../../../../links'
import { BankAccounts } from '../Screens/BankAccounts'
import { Cards } from '../Screens/Cards'
import { StyleSheet, Text } from 'react-native'
import { IBankAccountModel } from '@linqpal/models'

interface ViewAddedMethodsProps {
  onPress?: (arg: IBankAccountModel) => void
  setTab: (arg1: Tabs) => void
}

export const TOP_TAB_NAVIGATOR_HEIGHT = 39
const Tab = createMaterialTopTabNavigator()
export enum Tabs {
  BANKS = 'Banks',
  CARDS = 'Cards',
}

export const ViewAddedMethods: React.FC<ViewAddedMethodsProps> = ({
  onPress,
  setTab,
}) => {
  const store = useStore()
  const { accentText } = commonColors

  useEffect(() => {
    store.screensStore.paymentMethodsStore.fetchPaymentMethods()
  }, [store])

  return (
    <Tab.Navigator
      initialRouteName={Tabs.BANKS}
      initialLayout={{ width: screenWidth }}
      tabBarOptions={{
        activeTintColor: accentText,
        inactiveTintColor: '#335C75',
        indicatorStyle: styles.indicatorStyle,
        style: {
          backgroundColor: '#F4F9FD',
          height: TOP_TAB_NAVIGATOR_HEIGHT,
          borderRadius: 8,
          marginTop: 10,
          marginBottom: 15,
          justifyContent: 'center',
        },
      }}
      screenOptions={({ route }) => ({
        tabBarLabel: ({ focused }) => {
          return focused ? (
            <Text style={styles.focusedTabBarLabel}>{route.name}</Text>
          ) : (
            <Text style={styles.tabBarLabel}>{route.name}</Text>
          )
        },
      })}
      swipeEnabled={false}
    >
      <Tab.Screen
        name={paths.Console.More.Banks}
        listeners={{
          tabPress: () => {
            setTab(Tabs.BANKS)
          },
        }}
      >
        {() => <BankAccounts onPress={onPress} />}
      </Tab.Screen>
      <Tab.Screen
        name={paths.Console.More.Cards}
        listeners={{
          tabPress: () => {
            setTab(Tabs.CARDS)
          },
        }}
      >
        {() => <Cards onPress={onPress} />}
      </Tab.Screen>
    </Tab.Navigator>
  )
}

const styles = StyleSheet.create({
  tabBarLabel: {
    fontWeight: '500',
    fontSize: 14,
    color: '#335C75',
    width: 178,
    textAlign: 'center',
  },
  focusedTabBarLabel: {
    fontWeight: '600',
    fontSize: 14,
    color: '#00A0F3',
    width: 178,
    textAlign: 'center',
  },
  indicatorStyle: {
    backgroundColor: 'white',
    height: 33,
    marginVertical: 3,
    width: '48%',
    marginHorizontal: 3,
    borderRadius: 8,
  },
})
